import React from 'react'
import styled from 'styled-components'

const TransparentButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 20px;
  padding: 0;
  background: transparent;
  border: 0;
  text-align: center;
  cursor: pointer;

  &:focus {
    outline: 0;
  }
`

const MenuIcon = styled.i.attrs({ className: 'icon icon-hamburger' })`
  font-size: 15px;
`

const CloseIcon = styled.i.attrs({ className: 'icon icon-close' })`
  font-size: 18px;
`

const Hamburger = ({ open, onClick }) => (
  <TransparentButton onClick={onClick}>
    {open ? <CloseIcon /> : <MenuIcon />}
  </TransparentButton>
)

export default Hamburger



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout/components/NavBar/components/Hamburger/index.js